import React from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import db from "./firebase";
import firebase from "firebase";

const SignUpPage = () => {
  return <div></div>;
};

export default SignUpPage;
